﻿'use strict';

/**
 * @ngdoc directive
 * @name ntmApp.directive:homeTileContent
 * @description
 * # homeTileContent
 */
angular.module('ntmApp')
  .directive('homeTileContent', ['$timeout', '$sce', function ($timeout, $sce) {
      return {
          restrict: 'E',
          templateUrl: 'ng1/src/directives/templates/homeTileContent.html',
          scope: {
              content: '='
          },
          compile: function () {
              return {
                  pre: function link(scope) {

                      scope.showInstructions = function () {
                          return scope.content.instructions &&
                                 scope.content.instructions.showInstructions &&
                                 scope.content.instructions.instructions &&
                                 scope.content.instructions.instructions !== '';
                      };
                      scope.progressBarLabel = function (bar) {
                          return bar.showValues? '{0} out of {1} {2}'.format(bar.numerator,bar.denominator, bar.valueLabel):bar.valueLabel;
                      };

                      scope.trustAsHtml = function (html) {
                          return $sce.trustAsHtml(html);
                      };

                      scope.prepareData = function (bar) {
                          bar.displayAs = 'progressBar';
                          bar.val = bar.value;
                          return bar;
                      };

                  },

                  post: function link(scope, element) {

                      $timeout(function () {

                          var container = $(element).find('.tile-body');
                          var items = $(container).find('.tile-option');
                          var sortedItems = items.sort(function (itemA, itemB) {

                              var orderA = parseInt($(itemA).attr('data-sort'));
                              var orderB = parseInt($(itemB).attr('data-sort'));

                              return orderA - orderB;
                          });

                          $(container).empty();
                          $(container).append(sortedItems);
                      }, 0);
                  }
              };
          }
      };
  }]);